class Tab extends HTMLElement {
  constructor() {
    super()
    this.init()
  }

  init() {
    const ygProductTab = this.querySelectorAll('.yg-tab-frame li');
    const ygTabBox = this;
    const ygBtnBox = this.querySelector('.yg-tab-button');
    const ygBtn = this.querySelector('.yg-add-to-cart');
    const ygSectionList = document.querySelectorAll('#main .shopify-section');
    const ygProductTabContainer = this.querySelector('.yg-tab-frame');

    ygProductTab.forEach(function (e) {
      e.onclick = function () {
        // 获取点击项的data-point属性值
        let point = e.getAttribute('data-point');
        let number = e.getAttribute('data-section-number');
        // 遍历ygProductTab，移除所有激活类
        ygProductTab.forEach((a) => {
          a.classList.remove('active');
        });
        // 给当前点击项添加激活类
        // e.classList.add('active');
        if (number) {
          // 通过属性值获取dom节点
          let pointDom = ygSectionList[number];
          // 计算滚动距离
          console.log(parseInt(ygTabBox.style.top), ygTabBox.getBoundingClientRect().height, pointDom.offsetTop);
          let pointTop =
            pointDom.offsetTop - (parseInt(ygTabBox.style.top) || 0) - ygTabBox.getBoundingClientRect().height - 50;
          // 滑动到指定dom节点
          window.scrollTo({
            top: pointTop,
            behavior: 'smooth',
          });
        }
      };
    });
    // 添加点击事件监听器
    ygBtn.addEventListener('click', function () {
      // 模拟点击加入购物车按钮
      // 这里假设加入购物车按钮的类名为"button--secondary"
      // 你可以根据实际情况修改
      let addToCart = document.querySelector('.product .button[type="submit"][is="custom-button"]');
      addToCart.click();
    });
    let scrollTimer;

    // 添加滚动事件监听器
    window.addEventListener('scroll', function () {
      // 清除之前的定时器
      clearTimeout(scrollTimer);

      // 设置新的定时器
      scrollTimer = setTimeout(function () {
        // 在页面滚动停止后执行的操作
        const headerSection = document.querySelector('.header');

        let { height, top } = headerSection.getBoundingClientRect();
        // 剩下的代码保持不变
        if (headerSection) {
          let btnBoxTop = height + top >= 0 ? height - 1 + top : 0;

          if (!ygTabBox.parentNode.style.top) {
            ygTabBox.parentNode.style.position = 'sticky';
            ygTabBox.parentNode.style.top = btnBoxTop + 'px';
            // ygTabBox.parentNode.style.zIndex = '10';
          }
          ygTabBox.parentNode.style.top = btnBoxTop + 'px';

          if (ygTabBox.parentNode.getBoundingClientRect().top <= btnBoxTop) {
            ygBtnBox.style.width = '400px';
          } else {
            ygBtnBox.style.width = 0;
          }
        }
      }, 250); // 这里的 250 是延迟时间，单位为毫秒
    });

    const variantBlock = document.querySelector('.variant-picker');
    const priceEle = this.querySelector('.price-list')
    variantBlock?.addEventListener('click', (event) => {
      if (event.target !== variantBlock) {
        setTimeout(() => {
          const newElement = document.querySelector('.product-info .price-list')
          priceEle.innerHTML = newElement.innerHTML
        }, 1000);
      }
    })

    // const options = {
    //   threshold: [0.5]
    // }

    const debounce = (func, delay) => {
      let timeout;
      return function (...args) {
        clearTimeout(timeout);
        timeout = setTimeout(() => {
          func.apply(this, args);
        }, delay);
      };
    };

    // const intersectionObserver = new IntersectionObserver((entries) => {
    //   if ((entries[0].intersectionRatio > 0.5) || (window.innerHeight < entries[0].target.offsetHeight)) {
    //     console.log(entries[0].target.getAttribute('data-section-number'),'data-section-number',entries[0].target.height);
    //     ygProductTab.forEach((productTab) => {
    //       if(entries[0].target.getAttribute('data-section-number') == productTab.getAttribute('data-section-number')) {
    //         ygProductTab.forEach((ele) => {
    //           ele.classList.remove('active')
    //         })
    //         scrollProductTabContainer(productTab.offsetLeft);
    //         productTab.classList.add('active');
    //       }
    //     })
    //   }
    // }, options)

    const windowHeight = window.innerHeight

    window.addEventListener('scroll', () => {
      ygSectionList.forEach((item) => {
        if (item.getBoundingClientRect().top - (windowHeight * 2 / 3) < 0) {
          ygProductTab.forEach((productTab) => {
            if (item.getAttribute('data-section-number') == productTab.getAttribute('data-section-number')) {
              ygProductTab.forEach((ele) => {
                ele.classList.remove('active')
              })
              scrollProductTabContainer(productTab.offsetLeft);
              productTab.classList.add('active');
            }
          })
        }
      })
    })

    const scrollProductTabContainer = debounce((left) => {
      ygProductTabContainer.scrollTo({ left, behavior: 'smooth' });
    }, 300);

    ygSectionList.forEach(function (Section, i) {
      Section.setAttribute("data-section-number", i)
      // intersectionObserver.observe(Section);
    })
  }
}

if (!window.customElements.get('yg-tab')) {
  window.customElements.define('yg-tab', Tab)
}

class YGLike extends HTMLElement {
  constructor() {
    super();
    this.init();
  }

  init() {
    this.addEventListener('click', (e) => {
      e.target.closest('.product-card').querySelector('.product-card__quick-buy .button').click();

    })
  }
}

if (!window.customElements.get('yg-like')) {
  window.customElements.define('yg-like', YGLike);
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelector('.yg-to-top').addEventListener('click', function () {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  });

  if (window.scrollY > 100) {
    document.querySelector('.yg-to-top').classList.add('show');
  } else {
    document.querySelector('.yg-to-top').classList.remove('show');
  }

  window.addEventListener('scroll', function () {
    if (window.scrollY > 100) {
      document.querySelector('.yg-to-top').classList.add('show');
    } else {
      document.querySelector('.yg-to-top').classList.remove('show');
    }
  });
});

document.addEventListener('DOMContentLoaded', () => {
  class YGProductSwiper extends HTMLElement {
    constructor() {
      super()
      this.init()
    }
    init() {
      // 这里放置初始化逻辑
      this.initSwiper()
    }
    initSwiper() {
      // 这里放置自定义逻辑
      new Swiper(this, {
        spaceBetween: 12, //轮播中幻灯片之间的间距
        slidesPerView: 1.2, // 控制每次可见的幻灯片数量。这里设置为1，意味着一次只能看到一张幻灯片。
        pagination: {
          el: '.swiper-pagination',
          type: 'progressbar',
        },
        navigation: {
          //navigation: 配置轮播的前后导航按钮。
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        breakpoints: {
          //设置响应式断点
          700: {
            slidesPerView: 2.8,
            spaceBetween: 20,
          },
          1150: {
            slidesPerView: 4,
            spaceBetween: 20,
          },
        },
      });
    }
  }
  if (!window.customElements.get('yg-product-swiper')) {
    window.customElements.define('yg-product-swiper', YGProductSwiper)
  }

  class YGRecommendedList extends HTMLElement {
    constructor() {
      super()
      this.init()
    }
    init() {
      // 这里放置初始化逻辑
      this.initSwiper()
    }
    initSwiper() {
      // 这里放置自定义逻辑
      new Swiper(this, {
        spaceBetween: 20, //轮播中幻灯片之间的间距
        slidesPerView: 1.2,
        breakpoints: {
          1150: {
            slidesPerView: 2,
            spaceBetween: 20,
          },
        },
      });
    }
  }
  if (!window.customElements.get('yg-recommended-list')) {
    window.customElements.define('yg-recommended-list', YGRecommendedList)
  }

  class YGPopupBox extends HTMLElement {
    constructor() {
      super();
      this.addEventListener('click', (e) => {
        this.closePopup(e, () => { });
      });
    }

    openPopup($popupTemplate, fn) {
      // popupTemplate：需要替换的元素
      this.querySelector('.yg-popup-box-content-inner').innerHTML = $popupTemplate.innerHTML;
      document.querySelector('body').style.overflow = 'hidden';
      this.style.display = 'flex';
      fn();
    }
    closePopup(e, fn) {
      if (e.target.className == 'yg-popup-box-close' || e.target.className == 'yg-popup-box') {
        this.style.display = 'none';
        this.querySelector('.yg-popup-box-content-inner').innerHTML = '';
        document.querySelector('body').style.overflow = 'auto';
        fn();
      }
    }
  }
  if (!window.customElements.get('yg-popup-box')) {
    window.customElements.define('yg-popup-box', YGPopupBox);
  }

  class YGOpenPopup extends HTMLElement {
    constructor() {
      super();
      this.init();
      this.$popupBox = document.querySelector('.yg-popup-box');
    }
    init() {
      // 这里放置初始化逻辑
      this.addEventListener('click', this.itemClick.bind(this));
    }
    itemClick() {
      // 这里放置自定义逻辑
      let $popupTemplate = this.querySelector('template') || this.querySelector('.yg-popup-template');

      $popupTemplate && this.$popupBox.openPopup($popupTemplate, () => { });

    }
  }
  if (!window.customElements.get('yg-open-popup')) {
    window.customElements.define('yg-open-popup', YGOpenPopup);
  }

  class YGHotSpotSwiper extends HTMLElement {
    constructor() {
      super()
      this.init()
    }
    init() {
      this.initProductsSwiper
      this.initSwiper
      this.hotSpotClick()
    }

    hotSpotClick() {
      let $hotSpotItem = this.querySelectorAll('.yg-image-tab-content-item');

      $hotSpotItem.forEach(($item, i) => {
        let $hotSpots = $item.querySelectorAll('.hot-spot');

        $hotSpots.forEach(($hotSpot, i2) => {
          $hotSpot.addEventListener('click', () => {
            this.toggleItem(i2, this.initProductsSwiper[i])
          })
        })
      })
    }

    get initProductsSwiper() {
      let $productsSwiper = this.querySelectorAll('.yg-product-swiper');
      let productsSwiper = [];
      $productsSwiper.forEach(($product) => {
        let swiper = new Swiper($product, {
          spaceBetween: 20, //轮播中幻灯片之间的间距
          slidesPerView: 1,
        })

        productsSwiper.push(swiper)
      })

      return productsSwiper
    }

    get initSwiper() {
      let $hotSpotSwiper = this.querySelector('.yg-image-tab-content');
      return new Swiper($hotSpotSwiper, {
        spaceBetween: 20, //轮播中幻灯片之间的间距
        slidesPerView: 1,
        normalizeSlideIndex: false,
        pagination: {
          el: '.yg-image-tab-list',
          bulletClass: 'yg-image-tab-item text-base bold',
          bulletActiveClass: 'active',
          clickable: true,
          renderBullet: function (index, className) {
            return '<div class="yg-image-tab-item text-base bold">' + this.slides[index].dataset.title + '</div>';
          },
        }
      });
    }

    toggleItem(index, domArr) {
      if (!domArr) return;

      if (index == 0) { // 修复slide为第一个时, swiper未切换bug
        domArr.setTransition(300);
        domArr.setTranslate(0);
      } else {
        domArr.slideTo(index, 300, false)
      }

    }
  }
  if (!window.customElements.get('yg-hot-spot-swiper')) {
    window.customElements.define('yg-hot-spot-swiper', YGHotSpotSwiper)
  }

  class YGHotSpotSwiperNoTab extends HTMLElement {
    constructor() {
      super()
      this.init()
    }
    init() {
      this.initSwiper()
      // this.shuxjianting()
    }


    initSwiper() {
      new Swiper(this.querySelector('.yg-image-tab-content'), {
        simulateTouch: false,//禁用桌面端的拖拽
        breakpoints: {
          390: {
            slidesPerView: 1.2,
            spaceBetween: 8,
          },
          768: {
            slidesPerView: 2.2,
            spaceBetween: 20,
          }
        },
        scrollbar: {
          el: '.swiper-scrollbar',
        },
        navigation: {
          nextEl: '.swiper-next',
          prevEl: '.swiper-prev',
        },
      });
    }
  }
  if (!window.customElements.get('yg-spot-swiper-no-tab')) {
    window.customElements.define('yg-spot-swiper-no-tab', YGHotSpotSwiperNoTab)
  }

  class YGSupermenu extends HTMLElement {
    constructor() {
      super()
      this.init()
    }
    init() {
      this.mobiledrawer()
    }
    mobiledrawer() {
      const $this = document.querySelector("#header-sidebar-menu .yg-menu-super")
      const items = $this.querySelectorAll(".yg-link-transport .yg-links")
      items.forEach(el => {
        el.addEventListener("click", function () {
          items.forEach(item => {
            item.classList.remove("active")
          })
          el.classList.add("active")
        })
      })
    }
  }
  if (!window.customElements.get("yg-menu-super")) {
    window.customElements.define("yg-menu-super", YGSupermenu)
  }
  class YGGridImageList extends HTMLElement {
    constructor() {
      super()
      this.init()
    }
    init() {

    }
  }
  if (!window.customElements.get("yg-grid-image-list")) {
    window.customElements.define("yg-grid-image-list", YGGridImageList)
  }
  class YGvarinat extends HTMLElement {
    constructor() {
      super()
      this.init()
    }
    init() {
      this.varinat()
    }
    varinat(){
      const $varinatlist = this.querySelectorAll(".thumbnail-swatch")
      const $varinatdata = this.querySelectorAll("input.sr-only")
      $varinatlist.forEach((item,index)=>{
        item.addEventListener("mouseenter",function(){
          $varinatdata[index].click()
        })
      })
      
    }
  }
  if (!window.customElements.get("yg-varinat")) {
    window.customElements.define("yg-varinat", YGvarinat)
  }
  // class YGmedia extends HTMLElement{
  //   constructor() {
  //     super()
  //     this.init()
  //   }
  //   init() {
  //       this.media()
  //   }
  //   media(){
  //     const $meida = this.querySelectorAll(".media-grid__item")
  //     let $zhibiao
  //     const $meidabox = this.querySelector(".media-grid")
  //     $meida.forEach(el=>{
  //       if(getComputedStyle(el).getPropertyValue('--media-grid-row-span').trim() == 2){
  //         $zhibiao = el;
  //       }
  //     })
  //     $meidabox.style.setProperty('--yg-width',$zhibiao.offsetWidth+"px")
  //     window.onresize = function(){
  //       $meida.forEach(el=>{
  //         if(getComputedStyle(el).getPropertyValue('--media-grid-row-span').trim() == 2){
  //           $zhibiao = el;
  //         }
  //       })
  //     $meidabox.style.setProperty('--yg-width',$zhibiao.offsetWidth+"px")
  //     }
  //   }
  // }
  // if (!window.customElements.get("yg-media")) {
  //   window.customElements.define("yg-media", YGmedia)
  // }
})

